import audienceMixin from '../Mixins/audiences-table';

import {createNamespacedHelpers} from 'vuex';
const {mapState,mapActions} = createNamespacedHelpers('audienceManager/overview');

export default {
    name: 'inactive-overview',
    mixins: [audienceMixin],
    methods: {
        async reuseAudience(payload) {
            
            this.loading = true;
            await this.postAudienceStatus(payload);
            this.loading = false;

        },
        ...mapActions(['postAudienceStatus'])
    },
    computed: {
        reuseBtn() {
            return `
            <span class="custom-button" name="reuse" data-toggle="tooltip"
                title="${this.resource('AudienceManager_Overview_Inactive_Reuse_Tooltip')}"
            >
                <a href="javascript:void(0)" class="mdb-icon-btn">
                    <i class="fas fa-undo"></i>
                </a>
            </span>`;
        },
        inactiveAudiences() {
            const vm = this;
            
            return Object.values(vm.audiences).filter((audience) => 
                audience.status === vm.status.inactive
            );
        },
        allColumns() {
            return [...this.columns, {
                title: this.resource('AudienceManager_OverView_Inactive_Action'),
                defaultContent: this.reuseBtn,
                sortable: false
            }];
        }, 
        ...mapState(['audiences','loadingAudiences'])
    }
};